import { defineMessages } from 'react-intl';

export default defineMessages({
  courtManagerRecapTitle: {
    id: 'court_manager_legal_proceedings_page.recap_tab.title',
  },
  courtManagerJudgementAddTitle: {
    id: 'court_manager_legal_proceedings_page.judgement_add_tab.title',
  },
  courtManagerJudgementValidate: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.validate',
  },
  courtManagerJudgementUpdate: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.update',
  },
  courtManagerJudgementRefuse: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.refuse',
  },
  contestationDialogTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.contestation_dialog.title_message',
  },
  contestationDialogInstructionFieldTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_dialog.instruction',
  },
  contestationDialogCancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_dialog.cancel',
  },
  contestationDialogValidate: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_dialog.validate',
  },
  judiciaryProcessTabTitle: {
    id: 'first_tab.judiciary_process',
  },
  courtManagerJudgementRequestionAnnulation: {
    id:
      'court_manager_legal_proceedings_page.procedure_decision.request_annulation',
  },
  courtManagerJudgementFolderTo: {
    id: 'manager_recap_page_decision_button.title',
  },
  FeeNoteTitle: {
    id: 'side_bar.fee_note',
  },
  regulations: {
    id: 'legal-proceedings.regulations',
  },
  regulationRequest: {
    id: 'legal-proceedings.regulationRequest',
  },
  creation: {
    id: 'fee_note.add',
  },
  consultation: {
    id: 'fee_note.consulation',
  },
  civilProceedingTitle: {
    id: 'civil_proceeding_modal.title',
  },
  commercialproceedingTitle: {
    id: 'commercial_proceeding_modal.title',
  },
  basicInformation: {
    id: 'civil_proceeding_modal.basic_information.title',
  },
  hearingDateField: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.title',
  },
  dateReceiptRequestField: {
    id:
      'civil_proceeding_modal.basic_information.date_receipt_request_field.title',
  },
  courtNumber: {
    id: 'civil_proceeding_modal.basic_information.court_number.title',
  },
  victimsTitle: {
    id: 'civil_proceeding_modal.victims.title',
  },
  vehiclesTitle: {
    id: 'mission.vehicle_fields.title',
  },
  victimSelect: {
    id: 'civil_proceeding_modal.victims.select_victim',
  },
  addVictim: {
    id: 'preopening_page.victim.add_victim',
  },
  addOpposingParty: {
    id: 'civil_proceeding_modal.add_opposing_party',
  },
  assignAvocatTitle: {
    id: 'court_manager.civil_proceeding_modal.assign_avocat.title',
  },
  opposingLawyerField: {
    id: 'civil_proceeding_modal.opposingLawyer',
  },
  circomscriptionField: {
    id: 'civil_proceeding_modal.circomscription',
  },
  jurisdictionField: {
    id: 'civil_proceeding_modal.percentage_juridiction',
  },
  assignLawyer: {
    id: 'court_manager.civil_proceeding_modal.assign_avocat.assign_lawyer',
  },
  citation: {
    id: 'civil_proceeding_modal.upload_request_citation.title',
  },
  request: { id: 'civil_proceeding_modal.upload_request.title' },
  civilAdd: {
    id: 'save_btn',
  },
  civilCancel: {
    id: 'cancel_btn',
  },
  firstInstance: {
    id: 'court_manager.civil_proceeding_modal.juridction.first_instance',
  },
  appeal: {
    id: 'court_manager.civil_proceeding_modal.juridction.appeal',
  },
  provisionTab: {
    id: 'court_manager_legal_proceedings_page.provision_tab.title',
  },
  civilProceeding: {
    id: 'court_manager.civil_proceeding_modal.dropDownList.civil_proceeding',
  },
  commercialProceeding: {
    id:
      'court_manager.civil_proceeding_modal.dropDownList.commercial_proceeding',
  },
  correctionnelleProceeding: {
    id:
      'court_manager.civil_proceeding_modal.dropDownList.correctionnelle_proceeding',
  },
  AssignToSubService: {
    id: 'assignment_dialog.assign_to_sub_service',
  },
  damageAffectedByTheProcedure: {
    id: 'civil_proceeding_modal.damage_affected_by_the_procedure',
  },
  affectationProcedure: {
    id: 'court_manager.civil_proceeding_affectation',
  },
  AssignLawyer: {
    id: 'assignment_dialog.assign_lawyer',
  },
  opposingParties: {
    id: 'civil_proceeding_modal.opposingLawyer.title',
  },
  successDialogCivilProceeding: {
    id: 'civil_proceeding.success',
  },
  successDialogAddVictims: {
    id: 'add_victims_success',
  },
  uploadDocTitle: {
    id: 'court_manager.civil_proceeding.title_upload_docs',
  },
  town: {
    id: 'preopening_page.victim.city',
  },
  requestCivil: {
    id: 'legal_proceeding_page.request',
  },
  ExpertDrawerTitle: {
    id: 'Assign.expert_drawer.title',
  },
  cancelBtn: {
    id: 'cancel_btn',
  },
  saveBtn: {
    id: 'preopening_page.save',
  },
  lawyerConseil: {
    id: 'Assign.expert_drawer.lawyer_conseil',
  },
  ExpertJudiciareField: {
    id: 'Assign.expert_drawer.Expert_judiciare',
  },
  expertConseilField: {
    id: 'Assign.expert_drawer.Expert_conseil',
  },
  ExpertJudiciareHeureField: {
    id: 'Assign.expert_drawer.Expert_Hour',
  },
  managerActionTitle: {
    id: 'action.title',
  },
  AssignExpertTitle: {
    id: 'drawer.monitoring_manager.assign_expert_title',
  },
  ExlusionOfWarranty: {
    id: 'drawer.court_manager.exclusion_of_warranty_title',
  },

  AssignmentLawyerClaim: {
    id: 'drawer.court_manager.assignment_lawyer_title',
  },

  NatureProceeding: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.procedure.title',
  },
  supportingDocuments: {
    id: 'civil_proceeding.supportingDocuments',
  },
  step: {
    id: 'fee_note.step',
  },
  expertNature: {
    id: 'expertise.nature.title',
  },
  cityExpert: {
    id: 'preopening_page.victim.city',
  },
  AvocatConseil: {
    id: 'Assign.expert_drawer.lawyer_conseil',
  },
  ExpertJudiciare: {
    id: 'Assign.expert_drawer.Expert_judiciare',
  },
  ExpertHour: {
    id: 'Assign.expert_drawer.Expert_Hour',
  },
  ExpertAdress: {
    id: 'Assign.expert_drawer.adresse_expert',
  },
  ExpertDate: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.expert_fields.date',
  },
  AssignButton: {
    id: 'Assign.expert_drawer.button_assign',
  },
  UpdateButtonTitle: {
    id: 'Assign.expert_drawer.button_update',
  },
  AssignedToTitle: {
    id: 'Assign.expert_drawer.Expert_to_assign',
  },
  ExpertField: {
    id: 'Assign.expert_drawer.expert',
  },
  uploadConvocationTitle: {
    id: 'Assign.expert_drawer.expert_convocation',
  },
  comment: {
    id: 'legal_proceeding_page.judgement_on_merits.commentary_field',
  },
  ExlusionOfWarrantyReasonTitle: {
    id: 'drawer.court_manager.exclusion_of_warranty_reason_title',
  },
  validateWarrantyReason: {
    id: 'drawer.court_manager.validateWarrantyReason_title',
  },
  cancelWarrantyReason: {
    id: 'drawer.court_manager.cancelWarrantyReason_title',
  },
  successDialogWarrantyReason: {
    id: 'drawer.court_manager.validateWarrantyReason_succes_title',
  },
  successTitleAssign: {
    id: 'toast.success.assignedExpert.title',
  },
  courtManagerConfirmationDialogTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.title',
  },
  courtManagerConfirmationDialogCancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.cancel',
  },
  courtManagerConfirmationDialogConfirm: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.confirm',
  },
  courtManagerConfirmationDialogContent: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.content_message',
  },
  corporeal: {
    id: 'civil_proceeding_modal.corporeal',
  },
  material: {
    id: 'civil_proceeding_modal.material',
  },
  adverseVehicles: {
    id: 'civil_proceeding_modal.adverse-vehicles',
  },
  otherProperties: {
    id: 'civil_proceeding_modal.other-properties',
  },
  audience: {
    id: 'civil_proceeding_modal.audience',
  },
  vehicle: {
    id: 'court_manager.civil_proceeding_modal.vehicle',
  },
  claimInformationVehicleBrand: {
    id: 'claim_declaration.vehicle_brand',
  },
  registration: {
    id: 'preopening_page.claim_information.registration',
  },
  opposingCompanies: {
    id: 'preopening_page.claim_information.opposing_companies',
  },
  opposingFirstName: {
    id: 'claim_declaration.first_name',
  },
  opposingLastName: {
    id: 'claim_declaration.last_name',
  },
  claimNumber: {
    id: 'legal-proceedings.claim_number',
  },
  provision: {
    id: 'legal-proceedings.provision',
  },
  reglement: {
    id: 'legal-proceedings.reglement',
  },
  nombreVictimes: {
    id: 'legal-proceedings.nombre_victimes',
  },
  recours: {
    id: 'legal-proceedings.recours',
  },
  companyCost: {
    id: 'legal-proceedings.company_cost',
  },
  assignedLawyers: {
    id: 'legal-proceedings.assigned_lawyers',
  },
  feeNotes: {
    id: 'legal-proceedings.feeNotes',
  },

  updateFirmReference: {
    id: 'lawyer_modal.dropDownList.firm_reference',
  },
  createJom: {
    id: 'legal_proceeding_page.action.create_jom',
  },
  unvalidatedClaim: {
    id: 'claim.not_validated',
  },
  unvalidatedVictimsOrPa: {
    id: 'claim.with_unvalidated_victim_pa',
  },
  judgementOnMeritsLabelTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_label_title',
  },
  expertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.expertise',
  },
  appealOnMeritsLabelTitle: {
    id: 'legal_proceeding_page.appeal_on_merits_label_title',
  },
  ExpertUpdateDrawerTitle: {
    id: 'update_assigment.expert_drawer.title',
  },
  titleUpdateSuccess: {
    id: 'toast.success.updated_mission.title',
  },
  procedure: {
    id: 'expertise.recap_drawer.procedure',
  },
  receiptDateField: {
    id: 'mission.receipt_date.field.title',
  },
  missionWarningReceiptDateTitle: {
    id: 'mission.drawer.warning',
  },
  assignmentDialogAssignMultipleLawyers: {
    id: 'assignment_dialog.assign_multiple_lawyers',
  },
  updatedRequest: {
    id: 'toast.success.requestUpdated.title',
  },
  updateTitle: {
    id: 'general.title.update',
  },
  monitoringManagerDisabledTitle: {
    id: 'legal-proceedings.monitoring_manager.disable.title',
  },
  assignedLawyer: {
    id: 'drawer.court_manager.assignment_lawyer_name',
  },
  assignmentDate: {
    id: 'drawer.court_manager.assignment_date',
  },
  reassignmentDate: {
    id: 'drawer.court_manager.reassignment_date',
  },
  errorLockedClaim: {
    id: 'error.claim_is_locked_error',
  },
  suspiciousClaimTitle: {
    id: 'suspicious_claim.top_card.title',
  },
  suspiciousClaimDescription: {
    id: 'suspicious_claim.dialog.description',
  },
  suspiciousClaimToastSuccess: {
    id: 'suspicious_claim.dialog.success_toast',
  },
  suspiciousClaim: {
    id: 'claim.suspicios_claim.title',
  },
  hearingDateError: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.error',
  },
  topCardDocTitle: {
    id: 'top_card.document.title',
  },
  documentDrawerOther: {
    id: 'inboxe.document_drawer.other_document',
  },
  typeDocument: {
    id: 'upload_documents_page.upload_div.input',
  },
  decisionTitle: {
    id: 'recap_page.update.btn_decision',
  },
  updateDocumentImagingSucess: {
    id: 'manager_inboxes.drawer_imaging.decision_success',
  },
  disableCreateMission: {
    id: 'legal-proceedings.monitoring_manager.disable.create_mission.title',
  },
  alertTitle: { id: 'legal_proceeding_page.alert.quit' },
  alertQuitContent: { id: 'legal_proceeding_page.alert.quit.content' },
  missionRecieptDateError: {
    id: 'mission.reciept_date.error',
  },
  missionExpertiseDateError: {
    id: 'mission.expertise_date.error',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  associatedExperts: {
    id: 'drawer.monitoring_manager.associated_experts',
  },
  otherExperts: {
    id: 'drawer.monitoring_manager.other_experts',
  },
  trackingDrawerTitle: {
    id: 'tracking_drawer.title',
  },
  bawabaTitle: {
    id: 'tracking_drawer.bawaba_title',
  },
  sagisTitle: {
    id: 'tracking_drawer.sagis_title',
  },
  dialogValidationButton: {
    id: 'status_dialog.validate',
  },
  dialogCancelButton: {
    id: 'status_dialog.cancel',
  },
  statusTitle: {
    id: 'dialog_fee_note.update_fee_note.title',
  },
  statusTitleInput: {
    id: 'status_dialog.input_title',
  },
  successUpdateStatusTitle: {
    id: 'success_dialog.update_fee_note_status',
  },
  statusReasonTitle: {
    id: 'status_dialog.reason',
  },
  instructionTitle: { id: 'drawer.court_manager.instruction_title' },
  noDataTitle: {
    id: 'drawer.court_manager.instruction.empty_data',
  },
  toastSucess: {
    id: 'drawer.court_manager.instruction.created_successfully',
  },
  courtNumberTitle: {
    id: 'drawer.court_manager.court_number_title',
  },
  validateRequiredField: {
    id: 'validate.required_field',
  },
  classKeyValidation: {
    id: 'victim.add_class_key_validation',
  },
  transactionTabTitle: {
    id: 'transaction.legal_procedding.title',
  },
  generateAssignementLetter: {
    id: 'transaction.generate_assignement_letter.title',
  },
  registrationNumberAlert: {
    id: 'claim_declaration.registration_number.alert',
  },
  victimExcludedFromCoverageWarningMessage: {
    id: 'victim.excluded_from_coverage_warning_message',
  },
  basicManagementTitle: {
    id: 'basic_management.top_card.title',
  },
  allTitle: {
    id: 'tracking_drawer.all_title',
  },
  importDocumentTitleButton: {
    id: 'court_manager_page.legal_proceeding.import_document',
  },
  uploadDocumentTitle: {
    id: 'court_manager_page.legal_proceeding.upload_document',
  },
  upload: {
    id: 'upload_documents_page.upload_document_btn',
  },
  medicalExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.medicalExpertise',
  },
  accountingExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.accountingExpertise',
  },
  mechanicalExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.mechanicalExpertise',
  },
  warningTransactionTitle: {
    id: 'legal_proceeding_page.warning_transaction.title',
  },
  warningJudiciaryTitle: {
    id: 'legal_proceeding_page.warning_judiciary.title',
  },
  lastNameVictim: {
    id: 'search_bar.search_form_label_victim_name',
  },
  firstNameVictim: {
    id: 'monitoring_provisional_claim.victim.first_name',
  },
  victimField: {
    id: 'legal_proceeding_page.judgement_on_merits_info_title.victim',
  },
});
